import { render } from "./ContactForm.vue?vue&type=template&id=d79fd628"
import script from "./ContactForm.vue?vue&type=script&lang=js"
export * from "./ContactForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/frontend/js/components/ContactForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d79fd628"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d79fd628', __exports__)) {
    api.reload('d79fd628', __exports__)
  }
  
  module.hot.accept("./ContactForm.vue?vue&type=template&id=d79fd628", () => {
    api.rerender('d79fd628', render)
  })

}


export default __exports__